import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import FlipImagesListImagesScreen from "./FlipImagesListImagesScreen";

function FlipImagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Image Flipper & Image Rotator Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/flip_image", title: "Batch Image Flipper" },
    data2: { link: "/flip_image", title: "Flip & Rotate Images" },
    data3: { link: "/flip_image", title: "Mirror & Flip Images" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Flip and rotate images online easily. Rotate photos, flip images horizontally or vertically with our fast, secure image flipper and rotator tool."
      ></meta>
      <meta
        name="keywords"
        content="image flipper, image rotator, rotate image, flip image, rotate images online, flip images online, photo rotator, photo flipper, rotate pictures, flip pictures, image rotation tool, image flip tool, rotate image 90 degrees, rotate image 180 degrees, rotate image 360, flip image horizontal, flip image vertical, online image editor, image editing tool, free image rotator, mirror images, mirror image x axis, mirror image y axis, online image flipper, image flipper online, flip images online,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <FlipImagesListImagesScreen title={title}></FlipImagesListImagesScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
              "image/webp": [".webp"],
              "image/bmp": [".bmp"],
              "image/svg+sml": [".svg"],
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Image Flipper website offers a fast and user friendly way to flip and rotate images with perfect accuracy and high quality. This powerful tool allows users to flip images horizontally or vertically and rotate photos to the desired orientation in just a few clicks. Whether you need to correct camera orientation, create mirror images, or adjust photos for design and presentation, this platform works efficiently as a reliable image flipper online and image rotator. Supporting popular image formats such as JPG, PNG, and WebP, the tool ensures original image quality is preserved while you flip images or rotate them. With a clean interface and instant processing, users can upload images, preview changes in real time, and download the edited files immediately. Ideal for students, designers, photographers, and content creators, this image flipper helps save time and simplifies image editing tasks. If you are searching for an easy to use bulk image flipper online, a precise bulk image rotator, or a fast way to flip multiple images without complex software, this website delivers an efficient solution for everyday image editing needs." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Flip & Rotate",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Flip Images Tool"
            why_use={[
              {
                title: "Correct Image Orientation",
                description:
                  "Our image flipper helps fix incorrectly oriented photos by flipping images horizontally or vertically. Using an image flipper online or image rotator ensures images display correctly.",
              },
              {
                title: "Fix iOS Image Orientation Issues",
                description:
                  "Our image flipper tool helps fix iOS image orientation problems caused by EXIF rotation errors. Users can flip images to correct sideways or inverted photos from iPhone and iOS devices.",
              },
              {
                title: "Create Mirror and Reflection Effects",
                description:
                  "Flip images to create mirror or reflection effects for creative design, logos, and visual projects using an image flipper online.",
              },
              {
                title: "Fast and Simple Image Editing",
                description:
                  "Our image flipper online allows users to flip images instantly without complex photo editing software, saving time and effort.",
              },
              {
                title: "Useful for Design and Content Creation",
                description:
                  "Designers and content creators use image flipper and image rotator tools to adjust visuals for websites, presentations, and social media.",
              },
              {
                title: "Preserve Original Image Quality",
                description:
                  "High quality image flipper tools maintain resolution and clarity while flipping or rotating images for professional results.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Modern image flipper online tools support JPG, PNG, WebP, and other formats, making it easy to flip images of any type.",
              },
              {
                title: "Improve Image Alignment and Presentation",
                description:
                  "Using an image rotator or image flipper improves alignment, symmetry, and overall visual presentation of photos.",
              },
              {
                title: "Beginner-Friendly and Easy to Use",
                description:
                  "Our image flipper requires no technical or design skills, making it accessible for beginners and everyday users.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1071677375}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default FlipImagesMain;
